<template>
    <div>
        <star
            v-for="(star, index) in stars"
            :key="index"
            :class="{ 'mr-1': index !== 4 }"
            :is-half="star === 'half'"
            :empty="star === 'empty'"
            :color="star === 'empty' ? '#616468' : undefined"
        />
    </div>
</template>

<script>
import Star from "@/icons/Star.vue";

export default {
    name: "OfferWallRating",
    components: {
        Star
    },
    props: {
        rating: {
            type: Number,
            required: true
        },
        maxRating: {
            type: Number,
            required: false,
            default: 5
        }
    },
    computed: {
        stars() {
            const fullStars = Math.floor(this.rating);
            const halfStar = this.rating % 1 !== 0;
            const emptyStars = this.maxRating - fullStars - (halfStar ? 1 : 0);

            return [
                ...Array(fullStars).fill('full'),
                ...(halfStar ? ['half'] : []),
                ...Array(emptyStars).fill('empty')
            ];
        }
    }
}
</script>
